import { ScopeT } from 'business/definitions';
import { VisionState } from 'components/App/models';
import { useSelector } from 'react-redux';
import { camelizeScopeBlockNames } from './getScopesMiddlewares';

export const useGetScopes = (): ScopeT[] =>
    camelizeScopeBlockNames(
        useSelector((state: { vision: VisionState }) => state.vision.scopes),
    );
